import React from "react";
import "../../styles/components/browse_photographers_page/DateFilter.css";

export default function DateFilter({ value, onChange }) {
  return (
    <div className="date-filter">
      <label className="date-filter__control">
        <span className="date-filter__label">When?</span>
        <span className="date-filter__input-row">
          <input
            type="date"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            aria-label="When is the shoot?"
          />
          {value && (
            <button
              type="button"
              className="date-filter__clear"
              onClick={(event) => {
                event.preventDefault();
                onChange("");
              }}
              aria-label="Clear shoot date"
            >
              ×
            </button>
          )}
        </span>
      </label>
    </div>
  );
}
